import { Localization } from "@viamap/viamap2-common";
import { ADModalBody, AdvancedDragModal } from "src/componentsUtils/AdvancedDragModal";
import { useWindowContext } from "src/WindowManager/useWindowContext";
import { closeWindow, ManagedWindow } from "src/WindowManager/WindowState";

export function DownloadManager(props: { window: ManagedWindow }) {
   const { dispatch: windowDispatch } = useWindowContext();

   return (
      <AdvancedDragModal
         variant={"Small"}
         title={"Downloads"}
         window={props.window}
         PosDefault={{ left: "calc(100% - 6px)", top: "6px", transform: "translateX(-100%)" }}
         onClose={() => windowDispatch(closeWindow(props.window.id))}
      >
         <ADModalBody>
            {Localization.getText("Download manager content")}
         </ADModalBody>
      </AdvancedDragModal>
   )

}